module.exports = __webpack_public_path__ + "img/mp-funnels-1.65875c57.jpg";